import { render } from "./LoginsChart.vue?vue&type=template&id=c670f6a8"
import script from "./LoginsChart.vue?vue&type=script&lang=js"
export * from "./LoginsChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__